<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" ref="menuResize" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table newTable">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_161')" name="second" width="100%">
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
<!--              <tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes"-->
<!--                    ref="treeDisplay2"></tree>-->
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>

			<!-- <div class="dragBox" ref="dragResize"></div> -->
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<!-- <img style="width:100%;height:100%;" src="../../../static/img/buttonRight.png"> -->
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" ref="operaResize" :style="{'padding':width=='0px'?'0':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0;background-color: #F7F7F7;">
					<div class="treeMes">
						<p class="title"><span class="spot">{{'<'+(deviceDetailMes.name==undefined?$t('label_272'):deviceDetailMes.name)+">"}}</span>
							{{$t('label_519')}}</p>
						<div class="chooseBox spaceBetween" style="background-color:  #F7F7F7;">
							<div class="selectBox">
								<div>
									<div style="display: flex;align-items: center">
										<p style="margin-right: 20px">{{$t('label_524')}}</p>
										<div>
											<!-- <el-date-picker v-model="value1" type="datetimerange" unlink-panels format="yyyy-MM-dd HH:00" value-format="yyyy-MM-dd HH:mm"
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" style='width:355px;'>
											</el-date-picker> -->
											<el-date-picker v-model="value1[0]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:00"
											 value-format="yyyy-MM-dd HH:mm" style='width:180px;'>
											</el-date-picker>
											<span style="margin: 0 5px;">{{$t('label_264')}}</span>
											<el-date-picker v-model="value1[1]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:00"
											 value-format="yyyy-MM-dd HH:mm" style='width:180px;'>
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="searchs"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" style="height: auto">
							<div class='stateBox' v-for="(item,index) in analysisData" :class="item.check==true?'check':''" :style="{'background-color':item.color}">
								<div class='stateTitle'>{{item.title}}</div>
								<div class='verticalLine'></div>
								<div class='stateNumberBox'>
									<div class='stateNumberUp'>
										<span class='stateLabel'>{{$t('label_147')}}({{$t('label_647')}})</span>
										<span class='stateValue'>{{item.stateTime==''?0:item.stateTime}}</span>
									</div>
									<div class='stateNumberDown'>
										<span class='stateLabel'>{{$t('label_686')}}</span>
										<span class='stateValue'>{{item.stateCount==''?0:item.stateCount}}</span>
									</div>
								</div>
								<div class="checkBox">
									<el-checkbox class="checkbox" label="" v-model="item.check"></el-checkbox>
								</div>
							</div>
						</div>

						<div style='display: flex;'>
							<div class="left_container" style="margin-left:20px;">
								<div class="lft_box">{{$t('label_633')}}</div>
								<div id="echart1" style="width:98%;height:200px"></div>
								<div id="echart3" style="width:98%;height:calc(100vh - 680px);border:1px solid #D3D3D3;background-color: #ECECEC;">
								</div>
							</div>
							<div class="line"></div>
							<div class="left_container">
								<div class="lft_box">{{$t('label_637')}}</div>
								<div id="echart2" style="width:98%;height:200px;"></div>
								<div id="echart4" style="width:98%;height:calc(100vh - 680px);border:1px solid #D3D3D3;background-color: #ECECEC;">
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/equTree.vue";
  // import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import common from "@/assets/js/common/common.js";
	import echarts from "echarts"
	import signal from "@/assets/js/signal/signal.js";
	export default {
		name: 'mobileAnalysis',
		components: {
			tree,
			checkItem,
			electronDocument,
		},
		data() {
			return {
				beginTime: '',
				endTime: '',
				date_values: '',
				date_valuessss: '',
				value1: [],
				MenuRoleList: [],
				getTreeMes: '1',
				//checked: false,
				deviceDetailMes: {},
				// tableChooseInfo: {},
				treeShow: true,
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				activeNameTree: 'second',
				riskID: '0',
				riskList: [],
				Readytime: [],
				code: '',
				status: '',
				analysisData: [{
					title: this.$t('label_841'),
					color: this.$store.getters.getColor['3'].color,
					status: '3',
					stateTime: 0,
					stateCount: 0,
					check: true,
				}, {
					title: this.$t('label_858'),
					color: this.$store.getters.getColor['2'].color,
					stateTime: 0,
					stateCount: 0,
					check: true,
					status: '2',
				}, {
					title: this.$t('label_565'),
					color: this.$store.getters.getColor['1'].color,
					stateTime: 0,
					stateCount: 0,
					check: true,
					status: '1',
				}, {
					title: this.$t('label_843'),
					color: this.$store.getters.getColor['0'].color,
					stateTime: 0,
					stateCount: 0,
					check: true,
					status: '0',
				}],
				getList: [], // 接口获取的list
				valueList: [], // checklist
				// timeStatictis: [], // 时间统计数组
				timeStatictis: [{
					name: this.$t('label_858'),
					value: '0',
				},
				{
					name: this.$t('label_841'),
					value: '0',
				},
				{
					name: this.$t('label_843'),
					value: '0',
				},
				{
					name: this.$t('label_565'),
					value: '0',
				}],
				timeColor: [], // 时间统计颜色
				// countStatictis: [], // 次数统计数组
				countStatictis: [{
					name: this.$t('label_858'),
					value: '0',
				},
				{
					name: this.$t('label_841'),
					value: '0',
				},
				{
					name: this.$t('label_843'),
					value: '0',
				},
				{
					name: this.$t('label_565'),
					value: '0',
				}],
				frequencyColor: [], // 次数统计颜色
				timeBarData: [], //
				timeName: [this.$t('label_858'), this.$t('label_841'), this.$t('label_843'), this.$t('label_565')],
				timeBarDatas: [], //
				timeNames: [this.$t('label_858'), this.$t('label_841'), this.$t('label_843'), this.$t('label_565')],
				width: '340px',
				qrCodeShow: false,
				blList: []
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {

			showBtn() {
				console.log(111)
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
					//this.$refs.menuResize.style.width = "0px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth +"px";
				} else {
					this.width = "340px";
					//this.$refs.menuResize.style.width = "340px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth -340 +"px";
				}
			},
			updatetime(num) {
				let sdd = new Date(num);
				let yyyy = sdd.getFullYear();
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = (sdd.getHours() + 1) < 10 ? '0' + (sdd.getHours() + 1) : (sdd.getHours() + 1)
				// let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				// let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':' + '00' + '00'
			},
			dropSize() {
				let that = this,
					menuWidth = 200,
					operaHeight = 200;
				this.$refs.dragResize.onmousedown = function() {
					document.onmousemove = function(e) {
						let clientX = e.clientX;
						// 最大宽度
						if (clientX >= 800) {
							clientX = 800;
						}
						// 最小宽度
						if (clientX <= 495) {
							clientX = 495;
							// TODO 这里减的是最左侧tab的宽度
							menuWidth = clientX - 30;
						}
						that.$refs.menuResize.style.width = clientX - 275 + "px";
						that.$refs.operaResize.style.width = window.screen.width - clientX + 35 + "px";
						document.onmouseup = function() {
							document.onmousemove = null;
							document.onmouseup = null;
							that.releaseCapture && that.releaseCapture()
						}
					}
				}
			},
			// 获取时间
			getTime() {
				var $this = this;
				file.selectTimee().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.value1.push(data.data.beginTime, $this.updatetime(data.data.endTime))
						this.searchStauts()
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			checkRisk(type) {
				let data = this.riskList.filter(function(item) {
					return item.key == type.toString();
				});
				if (data != '') {
					return data[0].val
				}
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			// handleCurrentChangeTreeTime(info) {
			//   this.tableChooseInfo = info;
			// },

			// showDeviceMes(data) {
			//   this.$refs.treeDisplay.showCard(data.id);

			// },
			handleClickTree(tab, event) {
				this.getTreeMes = '0';
				this.deviceDetailMes = {};

			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.deviceDetailMes.name = this.$t('label_272')
				} else {
					this.deviceDetailMes = data;
					console.log(this.deviceDetailMes)
					this.searchStauts()
				}
			},
			searchStauts() {
				this.beginTime = this.value1[0] // 开始时间
				this.endTime = this.value1[1] //  结束时间
				// console.log('开始时间', this.beginTime)
				// console.log('结束时间', this.endTime)
				let date = new Date(this.value1[0]); //  时间格式准换
				let dates = new Date(this.value1[1]); //  时间格式准换
				// 时间格式化
				this.date_values = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' +
						+(date.getMonth() + 1) : date.getMonth() + 1) + '-' +
					(date.getDate() < 10 ? '0' +
						(date.getDate()) : date.getDate()) + ' ' +
					(date.getHours() < 10 ? '0' +
						(date.getHours()) : date.getHours()) + ':' + '00'
				this.date_valuessss = dates.getFullYear() + '-' +
					(dates.getMonth() + 1 < 10 ? '0' +
						(dates.getMonth() + 1) : dates.getMonth() + 1) + '-' +
					(dates.getDate() < 10 ? '0' +
						(dates.getDate()) : dates.getDate()) + ' ' +
					(dates.getHours() < 10 ? '0' +
						(dates.getHours()) : dates.getHours()) + ':' + '00'
				this.valueList = []
				for (let i = 0; i < this.analysisData.length; i++) { // 复选框状态
					if (this.analysisData[i].check == true) {
						this.valueList.push(this.analysisData[i].status);
					}
				}
				let param = {
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
					beginTime: this.date_values,
					endTime: this.date_valuessss,
					valueList: this.valueList
				}
				file.selectActivation(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.getList = data.data.list
						for (let i = 0; i < this.getList.length; i++) {
							if (this.getList[i].status == '3') {
								this.analysisData[0].stateTime = this.getList[i].value
								this.analysisData[0].stateCount = this.getList[i].count
							} else if (this.getList[i].status == '2') {
								this.analysisData[1].stateTime = this.getList[i].value
								this.analysisData[1].stateCount = this.getList[i].count
							} else if (this.getList[i].status == '1') {
								this.analysisData[2].stateTime = this.getList[i].value
								this.analysisData[2].stateCount = this.getList[i].count
							} else if (this.getList[i].status == '0') {
								this.analysisData[3].stateTime = this.getList[i].value
								this.analysisData[3].stateCount = this.getList[i].count
							}
						}
						let linshilist = [] // 时间统计
						let linshilists = [] // 次数统计
						linshilist = data.data.time
						linshilists = data.data.count
						this.blList = data.data.time
						this.timeBarData = []
						// this.timeStatictis = []
						this.timeColor = []
						// this.timeName = []
						// this.countStatictis = []
						this.frequencyColor = []
						this.timeBarDatas = []
						// this.timeNames = []
						for (let j = 0; j < linshilist.length; j++) {
							// this.timeStatictis.push({
							// 	value: linshilist[j].value,
							// 	name: this.$t(linshilist[j].name)
							// }) // 时间统计饼状图name value
							this.timeColor.push(linshilist[j].color) // 时间统计饼状图和柱状图颜色
							this.timeBarData.push(linshilist[j].value) // 时间统计柱状图value
							// this.timeName.push(this.$t(linshilist[j].name)) // 时间统计柱状图name
						}
						for (let j = 0; j < linshilists.length; j++) {
							// this.countStatictis.push({
							// 	value: linshilists[j].count,
							// 	name: this.$t(linshilists[j].name)
							// }) // 次数统计饼状图name value
							this.frequencyColor.push(linshilists[j].color) // 次数统计饼状图和柱状图颜色
							this.timeBarDatas.push(linshilists[j].count) // 次数统计柱状图value
							// this.timeNames.push(this.$t(linshilists[j].name)) // 次数统计柱状图name
						}
						this.search()
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchs() {
				this.valueList = []
				for (let i = 0; i < this.analysisData.length; i++) {
					if (this.analysisData[i].check == true) {
						this.valueList.push(this.analysisData[i].status);
					}
				}
				this.searchStauts()
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				let time = (new Date).getTime() + 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			drawPie(echartId, dataValue, timeColor, type) {
				// console.log('ffff',type)    // type==1 时间统计   2次数统计
				let echartO = echarts.init(document.getElementById(echartId));
				//eChartO.clear() 如果需要动态加载的需要加这个，在每次加载的时候清除画布
				if (type == 1) {
					let option = {
						color: timeColor,
						// title: {
						//   text: '11721分',
						//   left: 'center',
						//   top: 'center',
						// },
						tooltip: {
							show: false, // 关闭鼠标经过标签框
							trigger: 'item',
						},
						series: [{
							type: 'pie',
							radius: ['40%', '70%'], //环形大小
							center: ["50%", "50%"],
							avoidLabelOverlap: true, //是否启用防止标签重叠策略
							hoverAnimation: false, //关闭放大动画
							hoverOffset: 4,
							label: {
								normal: { //图形默认状态
									show: true,
									textStyle: {
										fontWeight: 600,
										fontSize: 18,
										color: '#4A4A4A'
									},
									formatter: '{d}%'
								}
							},
							// label: {
							//   show: false,
							//   position: 'center',
							//   formatter: '{c}分'
							// },
							labelLine: {
								normal: {
									show: false,
									length: 2,
									length2: 5
								}
							},
							emphasis: { //高亮状态
								label: {
									show: true,
									fontSize: '20',
								}
							},
							data: dataValue
						}]
					};
					echartO.setOption(option);
				} else {
					let option = {
						color: timeColor,
						// title: {
						//   text: '11721分',
						//   left: 'center',
						//   top: 'center',
						// },
						tooltip: {
							show: false,
							trigger: 'item',
						},
						series: [{
							type: 'pie',
							radius: ['40%', '70%'], //环形大小
							center: ["50%", "50%"],
							avoidLabelOverlap: true, //是否启用防止标签重叠策略
							hoverAnimation: false, //关闭放大动画
							hoverOffset: 4,
							label: { // 跟设计图一样 外圈有label
								normal: { //图形默认状态
									show: true,
									textStyle: {
										fontWeight: 600,
										fontSize: 18,
										color: '#4A4A4A'
									},
									formatter: '{d}%'
								}
							},
							// label: {
							//   show: false,
							//   position: 'center',
							//   formatter: '{c}次'
							// },
							labelLine: {
								normal: {
									show: false,
									length: 2,
									length2: 5
								}
							},
							emphasis: { //高亮状态
								label: {
									show: true,
									fontSize: '20',
								}
							},
							data: dataValue
						}]
					};
					echartO.setOption(option);
				}

			},
			drawBar(echartId, barData, lineData, timeColor, timeName) {
				let echartO = echarts.init(document.getElementById(echartId));
				let option = {
					grid: {
						x: 90,
						y: 30,
						x2: 50,
						y2: 35
					},
					tooltip: {
						trigger: 'axis', //触发类型,坐标轴触发
						transitionDuration: 0,
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					xAxis: [{
						type: 'category',
						data: timeName,
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
					}],
					yAxis: [{
							type: 'value',
							// min: 0,
							// max: 6000,
							// interval: 1000,
							name: (echartId == 'echart3' ? '(' + this.$t('label_647') + ')' : '(' + this.$t('label_207') + ')'),
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLine: {
								show: false
							},
						},
						{
							type: 'value',
							name: "（%）",
							nameLocation: 'end',
							min: 0,
							max: 100,
							interval: 10,
							axisTick: { //去掉刻度
								show: false
							},
							splitLine: { //去除网格线
								show: false
							},
							axisLine: { //去掉横轴
								show: false
							},
						}
					],
					series: [{
							name: (echartId == 'echart3' ? this.$t('label_147') : this.$t('label_755')),
							type: 'bar',
							barWidth: 35,
							data: barData,
							itemStyle: {
								normal: {
									color: function(params) {
										let colorList = timeColor;
										return colorList[params.dataIndex];
									}
								}
							}
						// },
						// {
						// 	name: this.$t('百分比'),
						// 	type: 'line',
						// 	yAxisIndex: 1,
						// 	data: lineData,
						// 	symbol: "circle",
						// 	symbolSize: 3,
						// 	itemStyle: {
						// 		normal: {
						// 			color: '#A9C0E1',
						// 			lineStyle: {
						// 				color: '#A9C0E1'
						// 			}
						// 		}
						// 	},
						}
					]
				};
				echartO.setOption(option);
			},
			search() {
				// https://blog.csdn.net/weixin_42995083/article/details/115216068  柏拉图参考
				// 时间统计帕拉图
				let ALL = this.timeBarData.map(x => x * 1).reduce((x, y) => {
					return x + y
				});
				let rate = this.timeBarData.map(x => {
					return {
						RATE: parseFloat(((x / ALL) * 100).toFixed(2))
					}
				});
				let rateData = [];
				for (let i = 0; i < rate.length; i++) {
					rateData.push(rate[i].RATE);
				}
				let index = 0;
				let ySeriesData = [];
				for (let i = 0; i < rateData.length; i++) {
					index += rateData[i];
					rateData[i] = parseFloat(index.toFixed(2));
          //todo 确定折线图显示形式后可修改
          // rateData[i] = parseFloat(rateData[i].toFixed(2));
					if (i != rateData.length - 1) {
						ySeriesData.push(rateData[i]);
					} else {
						rateData[i] = 100;
						ySeriesData.push(rateData[i]);
					}
				}
				// 次数统计帕拉图

				var ALLs = this.timeBarDatas.map(x => x * 1).reduce((x, y) => {
					return x + y
				});
				var rates = this.timeBarDatas.map(x => {
					return {
						RATE: parseFloat(((x / ALLs) * 100).toFixed(2))
					}
				});
				var rateDatas = [];
				for (let i = 0; i < rates.length; i++) {
					rateDatas.push(rates[i].RATE);
				}
				index = 0;
				var ySeriesDatas = [];
				for (let i = 0; i < rateDatas.length; i++) {
					index += rateDatas[i];
					rateDatas[i] = parseFloat(index.toFixed(2));
          //todo 确定折线图显示形式后可修改
          // rateData[i] = parseFloat(rateData[i].toFixed(2));
					if (i != rateDatas.length - 1) {
						ySeriesDatas.push(rateDatas[i]);
					} else {
						rateDatas[i] = 100;
						ySeriesDatas.push(rateDatas[i]);
					}
				}
				console.log(this.timeStatictis);
				console.log(this.countStatictis);
				console.log(this.timeBarData);
				console.log(this.timeBarDatas);
				this.drawPie('echart1', this.timeStatictis, this.timeColor, '1'); // 时间统计环形图
				this.drawPie('echart2', this.countStatictis, this.frequencyColor, '2'); // 次数统计环形图
				this.drawBar('echart3', this.timeBarData, ySeriesData, this.timeColor, this.timeName);
				this.drawBar('echart4', this.timeBarDatas, ySeriesDatas, this.frequencyColor, this.timeNames);
			},
		},
		//信号灯颜色查询
		selectSignalColor() {
			signal.selectSignalColor().then((response) => {
				const data = response.data;
				if (data.code == "1") {
					this.selectSignalColorList = data.data;
				}
			}).catch((response) => {
				console.log(response)
			})
		},
		mounted() {
			this.$nextTick(() => {
				this.dropSize();
			})
		},
		created() {
			this.getTime() // 获取时间
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style scoped>
	.el-autocomplete {
		display: none;
	}

	.spotMes2Box {
		display: flex;
	}

	.spotMes2Box .stateBox {
		display: flex;
		width: 25%;
		height: 110px;
		/* margin: 0px 2%; */
		border: 1px solid #dcdcdc;
		padding: 20px;
		align-items: center;
		white-space: nowrap;
		background-color: #EFEFEF;
		margin-left: 15px;
	}

	.spotMes2Box .check {
		border: 1px solid #3fb393;
	}

	.stateTitle {
		align-self: center;
		vertical-align: middle;
		text-align: center;
		font-weight: bold;
	}

	.verticalLine {
		width: 2px;
		height: 90%;
		margin: 10% 10px;
		border-left: 2px solid #DBDBDB;
	}

	.stateNumberBox {
		height: 100%;
		width: 80%;
	}

	.stateNumberUp {
		height: 30px;
		width: 100%;
		margin-top: 10px;
	}

	.stateNumberDown {
		height: 50%;
		width: 100%;
	}

	.stateLabel {
		display: inline-flex;
		width: 70px;
		color: #000000;
	}

	.checkBox {
		height: 100%;
		vertical-align: top;
	}

	.lft_box {
		font-size: 20px;
		font-weight: bold;
	}

	.left_container {
		width: 50%;
	}

	.line {
		width: 2%;
		border-left: 1px solid #dcdcdc;
		margin-left: 20px;
		margin-top: 28px;
	}

	.checkbox {
		zoom: 200%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentOperation/mobileAnalysis.vue